export const actionTypes = {
	SetPosts: '[Posts] SetPosts',
	SetTopItems: '[Posts] SetTopItems',
	SetMostPopular: '[Posts] SetMostPopular',
	UpdateFilter: '[Posts] UpdateFilter',
	UpdateLoading: '[Posts] UpdateLoading',
};

export const initialPosts = {
	filter: {
		type: 'all',
	},
	topItems: [],
	mostPopular: [],
	loading: true,
};

export const reducer = (state = initialPosts, { type, payload }) => {
	switch (type) {
		case actionTypes.SetMostPopular:
			return {
				...state,
				mostPopular: payload,
				loading: false,
			};
		case actionTypes.SetTopItems:
			return {
				...state,
				topItems: payload,
				loading: false,
			};
		case actionTypes.UpdateFilter:
			return {
				...state,
				filter: {
					...state.filter,
					...payload,
				},
			};
		case actionTypes.UpdateLoading:
			return {
				...state,
				loading: payload,
			};
		default:
			return state;
	}
};

export const actions = {
	setMostPopular: (payload) => ({ type: actionTypes.SetMostPopular, payload }),
	setTopItems: (payload) => ({ type: actionTypes.SetTopItems, payload }),
	updateFilter: (payload) => ({ type: actionTypes.UpdateFilter, payload }),
	updateLoading: (payload) => ({ type: actionTypes.UpdateLoading, payload }),
};

export function* saga() {}
